module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_red-joker.d8a1b9cb.svg";